<template>
  <div class="container mt-2">
    <!-- <div class="d-flex flex-row align-items-center justify-content-left gap-2 mb-2">
      <router-link to="/personas" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="tooltip-text">{{ $t('volver') }}</span>
      </router-link>
      <h2 class="m-0">{{ $t('roles') }}</h2>
    </div> -->
    <div class="d-flex flex-row align-items-center gap-2 mb-2">
      <input type="text" class="form-control m-0 sombra-sm" :placeholder="$t('buscarPorNombre')+'...'" v-model="searchTerm" @input="filterUsers"/>
      <router-link to="/personas/crearRoles" class="btn bg-goethe-accent p-1 rounded sombra-sm">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 12H18M12 6V18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </router-link>
    </div>

    <table class="table-striped w-100 mb-2 sombra-sm">
      <thead>
        <tr>
          <th @click="sortTable('Rol')" style="cursor: pointer;" class="user-select-none">
            {{ $t('rol') }}
            <span v-if="sortKey === 'Rol'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th @click="sortTable('Rol')" style="cursor: pointer;" class="user-select-none">
            {{ $t('descripcion') }}
            <span v-if="sortKey === 'Rol'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th @click="sortTable('Permisos')" style="cursor: pointer;" class="user-select-none">
            {{ $t('permisos') }}
            <span v-if="sortKey === 'Permisos'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="rol in roles" :key="rol.IdRol">
          <!-- Fila de información del usuario -->
          <tr  @click="toggleDetalle(rol.IdRol)" style="cursor: pointer;">
            <td class="fs-8 align-middle p-2">
              <p class="m-0">{{ rol.Rol }}</p>
            </td>
            <td class="fs-8 align-middle p-2">
              <p class="m-0">{{ rol.Descripcion }}</p>
            </td>
            <td class="fs-8 align-middle p-2">
              <p class="m-0">{{ rol.Permisos && rol.Permisos.length > 0 ? rol.Permisos.map(permiso => permiso.permiso).join(', ') :  $t('sinPermisos') }}</p>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
      <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
    </div>

    <!-- Controles de Paginación --> 
    <nav aria-label="Page navigation" class="d-flex flex-row justify-content-between">
      <ul class="pagination">
        <li class="p-2 rounded-start bg-goethe-accent-claro-3 borde-secundario border-1 border-end sombra-sm" :class="{ disabled: currentPage === 1 }">
          <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="prevPage()">{{ $t('anterior') }}</a>
        </li>
        <li class="p-2 bg-goethe-accent-claro-3 borde-secundario sombra-sm">
          <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="">{{ currentPage }} {{$t('de')}} {{ totalPages }}</a>
        </li>
        <li class="p-2 rounded-end bg-goethe-accent-claro-3 borde-secundario border-1 border-start sombra-sm" :class="{ disabled: currentPage === totalPages }">
          <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="nextPage()">{{ $t('siguiente') }}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import { ref, onMounted, computed } from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  name: 'VerRoles',
  setup() {
    const { t } = useI18n();
    const roles = ref([]);
    const searchTerm = ref('');
    const currentPage = ref(1);
    const itemsPerPage = 15; // Número de usuarios por página
    var loading = ref(false);
    var hasRolesPermission = ref(false);
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const sortKey = ref('');
    const sortDirection = ref('asc'); // 'asc' o 'desc'

    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        
        var permisoAComprobar = 'ManejarRoles'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          console.log("Tiene Permiso")
          hasRolesPermission.value = true;
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
      }
    };

    const fetchRoles = async () => {
      try {
        loading.value = true
        const response = await api.get(`api/Roles`);
        roles.value = response.data; // Asumiendo que la respuesta contiene un array de usuarios
        console.log(roles.value)
        loading.value = false
      } catch (error) {
        console.error('Error al obtener usuarios:', error);
        loading.value = false
      }
    };

    const totalPages = computed(() => {
      const filteredCount = roles.value.filter(rol => 
        (rol.Rol && rol.Rol.toLowerCase().includes(searchTerm.value.toLowerCase()))
      ).length;
      return Math.ceil(filteredCount / itemsPerPage);
    });

    const changePage = (page) => {
      if (page < 1 || page > totalPages.value) return; // Validar el cambio de página
      currentPage.value = page;
    };

    const toggleDetalle = async (rolId) => {
      await router.push(`/personas/editarRoles?id=${rolId}`);
    };

    const sortedAndFilteredUsers = computed(() => {
      const filtered = roles.value.filter(rol => 
        (rol.Rol && rol.Rol.toLowerCase().includes(searchTerm.value.toLowerCase()))
      );

      const sorted = filtered.sort((a, b) => {
        let sortA, sortB;
        

        sortA = (a[sortKey.value] || '').toLowerCase(); // Asegúrate de que a[sortKey.value] no sea null
        sortB = (b[sortKey.value] || '').toLowerCase(); // Asegúrate de que b[sortKey.value] no sea null

        if (sortDirection.value === 'asc') {
          return sortA > sortB ? 1 : sortA < sortB ? -1 : 0;
        } else {
          return sortA < sortB ? 1 : sortA > sortB ? -1 : 0;
        }
      });

      const start = (currentPage.value - 1) * itemsPerPage;
      return sorted.slice(start, start + itemsPerPage);
    });


    const sortTable = (key) => {
      if (sortKey.value === key) {
        // Si es la misma columna, invierte la dirección de orden
        sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
      } else {
        // Si es una nueva columna, ordena ascendentemente
        sortKey.value = key;
        sortDirection.value = 'asc';
      }
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();
      fetchRoles();
    });

    return {
      searchTerm,
      changePage,
      currentPage,
      totalPages,
      sortedAndFilteredUsers,
      sortTable,
      checkAuth,
      sortKey,
      sortDirection,
      toggleDetalle,
      loading,
      t,
      hasRolesPermission,
      roles,
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}
</style>
